import { render, staticRenderFns } from "./CampaignReport.vue?vue&type=template&id=48950b2a&scoped=true&lang=pug&"
import script from "./CampaignReport.vue?vue&type=script&lang=js&"
export * from "./CampaignReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48950b2a",
  null
  
)

export default component.exports